var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3334 25.5041C21.444 25.8274 22.6184 26.0007 23.8333 26.0007C25.805 26.0007 27.6701 25.5442 29.3286 24.7312C29.3317 24.6547 29.3333 24.5779 29.3333 24.5007C29.3333 21.4632 26.8709 19.0007 23.8333 19.0007C21.9426 19.0007 20.2747 19.9548 19.2848 21.4077M20.3334 25.5041V25.5007C20.3334 24.0169 19.9531 22.6218 19.2848 21.4077M20.3334 25.5041C20.3334 25.5517 20.3329 25.5991 20.3321 25.6465C17.8499 27.1411 14.942 28.0007 11.8334 28.0007C8.72474 28.0007 5.8169 27.1411 3.3346 25.6465C3.33379 25.598 3.33337 25.5494 3.33337 25.5007C3.33337 20.8063 7.13895 17.0007 11.8334 17.0007C15.0439 17.0007 17.8387 18.7807 19.2848 21.4077M16.3334 8.50073C16.3334 10.986 14.3187 13.0007 11.8334 13.0007C9.34809 13.0007 7.33337 10.986 7.33337 8.50073C7.33337 6.01545 9.34809 4.00073 11.8334 4.00073C14.3187 4.00073 16.3334 6.01545 16.3334 8.50073ZM27.3334 11.5007C27.3334 13.4337 25.7664 15.0007 23.8334 15.0007C21.9004 15.0007 20.3334 13.4337 20.3334 11.5007C20.3334 9.56774 21.9004 8.00073 23.8334 8.00073C25.7664 8.00073 27.3334 9.56774 27.3334 11.5007Z",
    stroke: "#22D3EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1a482c12d0abe7a96a03063ecb27a916.svg";
export { ForwardRef as ReactComponent };